<template>
	<layout title="Daftar Transaksi">
		<template v-slot:content>
			<main class="p-6" style="background: white !important;">
				<!-- Form Filter -->
				<form-filter />
				<!-- / -->

				<!-- Status -->
				<transaction-status />
				<!-- / -->

				<main>
					<p class="text-center w-full" v-if="transactionData.length < 1">
						Tidak ada transaksi
					</p>
					<div v-else>
						<div
							v-for="(item, i) in transactionData"
							:key="i"
							class="mb-6"
						>
							<vx-card>
								<div class="vx-row">
									<div class="vx-col w-full md:w-3/4">
										<div class="flex flex-col md:flex-row items-start md:items-center mb-4">
											<strong class="block mr-4 mb-4 md:mb-0">Pulsa</strong>
											<strong class="block mr-4 mb-4 md:mb-0 text-grey">18 Mar 2022</strong>
											<div class="con-vs-alert-success px-2 py-0 mr-4 mb-4 md:mb-0">
												<small><strong>Berhasil</strong></small>
											</div>
											<p class="mr-4 text-grey mb-4 md:mb-0">IVR/202228392/XXI/ii</p>
										</div>
										<div class="mb-4">
											<strong>Nominal</strong>
										</div>
										<div class="mb-4">
											<strong>No Hp</strong>
										</div>
									</div>

									<div class="vx-col w-full md:w-1/4">
										<div class="flex flex-col justify-center w-full">
											<div class="mb-4">
												<strong>Total Harga</strong>
											</div>
											<div class="mb-4">
												<strong>18.000</strong>
											</div>
										</div>
											
									</div>
									<div class="vx-col w-full">
										<div class="flex justify-center md:justify-end">
											<div class="flex items-center">
												<router-link to="/" class="mr-4">
													<strong class="text-primary">
														<small>Lihat Detail Transaksi</small>
													</strong>
												</router-link>

												<vs-button >
													<strong class="text-white"><small>Beli Lagi</small></strong>
												</vs-button>
											</div>
										</div>
									</div>
								</div>
							</vx-card>
						</div>
					</div>
				</main>
			</main>
				

		</template>
	</layout>
</template>
<script>
	export default {
		data: () => ({
			transactionData: [
				{
					id: 1
				},
				{
					id: 1
				}
			]
		}),
		components: {
			Layout: () => import('./components/Layout.vue'),
			TransactionStatus: () => import('./components/TransactionStatus.vue'),
			FormFilter: () => import('./components/FormFilter.vue')
		}
	}
</script>